import axios from 'axios'
import store from './store'
import router from './router'

import config from './../config/project.config'

axios.defaults.baseURL = config.globals.API_URL_POST

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.patch['Content-Type'] = 'application/x-www-form-urlencoded'

let HTTP3 = axios.create({
  baseURL: `${config.globals.API_URL}/api`,
  timeout: 120000,
  validateStatus: function (status) {
    if (status === 401) {
      store.commit('changeLoginStatus', false)
      store.state.user.isLogin = false
      router.push({ path: '/' })
      window.localStorage.clear()
      location.reload()

      return false
    }

    return status >= 200 && status < 300
  }
})

const HTTP = axios.create()

export default { HTTP, HTTP3 }
